/**
 *
 * Records Page
 *
 */
import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import moment from "moment"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  Card,
  CardBody,
} from "reactstrap"
import { withRouter, useParams } from "react-router-dom"
import ButtonSpinner from "../../components/ButtonSpinner"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as birthdayAction from "../../store/QmlydGhkYXkgbGlzdA/actions"
import { useSelector, useDispatch } from "react-redux"
import Select from "react-select"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit"

//Import Styles
import "./styles.scss"

const BirthdayList = (props) => {
  const { dispatch, searchBarStyle } = props
  const specificDispatch = useDispatch()
  let { id } = useParams()

  const { ExportCSVButton } = CSVExport

  console.log(id, dispatch)
  const { SearchBar } = Search

  useEffect(() => {
    dispatch(birthdayAction.loadRecordsMetaData())
    dispatch(birthdayAction.loadBirthdayList())
  }, [])

  const update = useSelector((specificstate) => specificstate)
  const birthdayListUpdate = useSelector(
    (specificstate) => specificstate.birthdayList
  )
  const { recordsMetaData = {}, birthday_list = [] } = birthdayListUpdate

  //Date format
  const sessionUpdate = useSelector((specificState) => specificState.session)
  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  console.log(birthdayListUpdate, "employee Update")
  console.log(recordsMetaData, "employee Update")
  console.log(birthday_list, "employee Update")
  console.log(update, "Total store values")

  const [btnLoader, setBtnLoader] = useState(false)

  const [birthData, setBirthData] = useState({
    companyid: id,
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    responseStatus: [],
  })

  const handleChange = (e) => {
    setBirthData({ ...birthData, [e.target.name]: e.target.value })
  }

  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [designation, setDesignation] = useState([])

  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )
  const designationOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.designationOptions.filter(
      (designation) => designation.departmentId === departmentList.value
    )
  const company = !isEmpty(companies) && companies.value
  const branch = !isEmpty(branches) && branches.value
  const department = !isEmpty(departmentList) && departmentList.value
  const startDate = birthData.fromDate
  const endDate = birthData.toDate

  console.log(
    company,
    branch,
    department,
    startDate,
    endDate,
    "dropdown outputs"
  )

  const handleApply = () => {
    // const processStatus = process.processStatusId
    var searchCompany = companies && companies.value ? [companies.value] : ""
    var searchBranch = branches && branches.value ? [branches.value] : ""
    var searchDepartment =
      departmentList && departmentList.value ? [departmentList.value] : ""
    var searchDesignation =
      designation && designation.value ? [designation.value] : ""
    var searchFromDate =
      birthData && birthData.fromDate ? birthData.fromDate : ""
    var searchToDate = birthData && birthData.toDate ? birthData.toDate : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.company = searchCompany
    }
    if (searchBranch) {
      searchvalue.branch = searchBranch
    }
    if (searchDepartment) {
      searchvalue.department = searchDepartment
    }
    if (searchDesignation) {
      searchvalue.designation = searchDesignation
    }
    if (searchFromDate) {
      searchvalue.startDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.endDate = searchToDate
    }

    console.log("searchCompany", searchvalue)
    specificDispatch(birthdayAction.loadBirthdayList(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  const resetFormDetails = () => {
    setDepartmentList([])
    setCompanies([])
    setBranches([])
    setBirthData({
      fromDate: "",
      toDate: "",
    })
  }

  const date = new Date()

  const month = date.getMonth() + 1

  console.log(month, "month")

  let slNo = 0
  const dataTable = !isEmpty(birthday_list)
    ? birthday_list.map((employee, index) => {
        // if (companyId === employee.companyId) {

        const date = new Date()

        const month = date.getMonth() + 1

        console.log(month, "month")

        const dob = moment(employee.dob).month() + 1

        console.log(dob, "DOb")
        var dateOfBirth = !isEmpty(employee.dob)
          ? moment(employee.dob)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []

        if (month === dob) {
          slNo = slNo + 1
          return {
            _id: employee._id,
            sNo: slNo,
            ReponseNotes: employee.ReponseNotes,
            branchId: employee.branchId,
            branchName: employee.branchName,
            companyId: employee.companyId,
            companyName: employee.companyName,
            departmentId: employee.departmentId,
            departmentName: employee.departmentName,
            description: employee.description,
            designationId: employee.designationId,
            dob: dateOfBirth,
            designationName: employee.designationName,
            employeeCode: employee.employeeCode,
            employeeName: employee.employeeName,
            requestNo: employee.requestNo,
            requestStatus: employee.requestStatus,
            responseEmployeeCode: employee.responseEmployeeCode,
            responseEmployeeName: employee.responseEmployeeName,
            subject: employee.subject,
            key: index,
          }
        }
      })
    : []

  const dataTableArray = !isEmpty(dataTable)
    ? dataTable.filter((data) => data !== undefined)
    : []

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "employeeCode",
      text: "Employee Code",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "75px",
      },
    },
    {
      dataField: "departmentName",
      text: "Department",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "designationName",
      text: "Designation",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "dob",
      text: "Date of Birth",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
  ]

  console.log(dataTable, "data table")

  const title = "Birthday List"

  const options = {
    sizePerPage: 10,
    totalSize: dataTableArray.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "<",
    nextPageText: ">",
    lastPageText: ">>",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"HRMS"} breadcrumbItem={title} />

          <Row>
            <Col lg="12" md="12" sm="12" xs="12" style={{paddingRight: "24px"}} className="birthday-list-card">
              <Card>
                <CardBody>
                  <Row>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <FormGroup>
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Company"}>
                          {"Company"}
                        </Label>
                      </div>

                      <Select
                        type="text"
                        name="company"
                        value={companies}
                        onChange={(e) => setCompanies(e)}
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        classNamePrefix="select2-selection"
                        placeholder="Select Company"
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <FormGroup>
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Branch"}>
                          {"Branch"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="branch"
                        value={branches}
                        onChange={(e) => setBranches(e)}
                        placeholder="Select Branch"
                        classNamePrefix="select2-selection"
                        options={branchOptions}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <FormGroup>
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Department"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="department"
                        value={departmentList}
                        onChange={(e) => setDepartmentList(e)}
                        placeholder="Select Department"
                        classNamePrefix="select2-selection"
                        options={
                          recordsMetaData
                            ? recordsMetaData.departmentOptions
                            : []
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <FormGroup>
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Response status"}
                        >
                          {"Designation"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="designation"
                        value={designation}
                        onChange={(e) => setDesignation(e)}
                        placeholder="Select Designation"
                        classNamePrefix="select2-selection"
                        options={designationOptions}
                      />
                    </FormGroup>
                  </Col>

                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <Label className="event-label">From Date</Label>
                    <Input
                      type="date"
                      name="fromDate"
                      value={birthData.fromDate}
                      onChange={(e) => handleChange(e)}
                      placeholder="Select Date"
                    />
                  </Col>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <Label className="event-label">To Date</Label>
                    <Input
                      type="date"
                      name="toDate"
                      value={birthData.toDate}
                      onChange={(e) => handleChange(e)}
                      placeholder="Select Date"
                    />
                  </Col>
                  <Col xl="12" lg="12" md="12" className="filter-section">
                    <div className="filter-buttons">
                      <button
                        type="reset"
                        className="btn btn-danger btn-label simple-form-Reset-btn mx-2 form-submit-btn"
                        onClick={() => resetFormDetails()}
                      >
                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                        Reset
                      </button>
                      <button
                        type="button"
                        className="mx-2 btn btn-success btn-label form-submit-btn"
                        onClick={() => handleApply()}
                      >
                        <i
                          className="bx bx-filter-alt label-icon"
                          style={{ fontSize: "12px" }}
                        ></i>
                        {btnLoader && btnLoader ? (
                          <ButtonSpinner />
                        ) : (
                          "Apply Filter"
                        )}{" "}
                      </button>
                    </div>
                  </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Col className="sales-approval-card mt-3">
            <Row>
              <Col md="12" lg="12" xl="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(options)}
                      keyField="_id"
                      columns={columns}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          data={dataTableArray}
                          columns={columns}
                          search
                        >
                          {(props) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row  ">
                                  <Col className="mb-3" md="4">
                                    <div className="d-flex flex-row ">
                                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <div
                                          className="position-relative mt-7"
                                          style={searchBarStyle || null}
                                        >
                                          <SearchBar {...props.searchProps} />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </div>{" "}
                                  </Col>
                                  <Col>
                                    <ExportCSVButton
                                      className="border float-right mx-10"
                                      style={{
                                        float: "right",
                                        backgroundColor: "#e40d8c",
                                        color: "#ffffff",
                                      }}
                                      {...props.csvProps}
                                    >
                                      Download{" "}
                                    </ExportCSVButton>{" "}
                                  </Col>

                                  <Col>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      responsive
                                      striped={true}
                                      bordered={true}
                                      keyField="_id"
                                      columns={columns}
                                      //  filter={ filterFactory() }
                                      // expandRow={expandRow}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  )
}

BirthdayList.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  birthday_list: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  searchBarStyle: PropTypes.any,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapStateToProps = (state) => ({
  birthday_list: state.birthdayList.birthday_list,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BirthdayList)
)
